export const QUESTION_PROTECTION = [
    {
        id: 1,
        question: 'Nombres y apellidos',
        value: 'name'
    },
    {
        id: 2,
        question: 'Edad',
        value: 'age'
    },
    {
        id: 3,
        question: 'Correo electrónico',
        value: 'email'
    },
    {
        id: 4,
        question: 'País de residencia',
        value: 'country'
    },
    {
        id: 5,
        question: '¿Cuántas personas dependen de ti actualmente?',
        value: 'peopleDepend'
    },
    {
        id: 6,
        question: '¿Cuál es el monto de tu Patrimonio aproximadamente? (USD) (ahorros, inversiones, propiedades, etc)',
        value: 'amountHeritage'
    },
    {
        id: 7,
        question: '¿Cuánto ganas mensualmente aproximadamente? ( USD )',
        value: 'salaryMonthly'
    },
    {
        id: 8,
        question: '¿Con qué monto mensual consideras que tu familia viviría de manera holgada incluyendo los costos',
        value: 'amountFamily'
    }
]

export const QUESTION_BUILD = [
    {
        id: 1,
        question: 'Nombres y apellidos',
        value: 'name'
    },
    {
        id: 2,
        question: 'Edad',
        value: 'age'
    },
    {
        id: 3,
        question: 'Correo electrónico',
        value: 'email'
    },
    {
        id: 4,
        question: 'País de residencia',
        value: 'country'
    },
    {
        id: 5,
        question: '¿A qué edad te gustaría poder vivir de tu portafolio? (sugerimos una edad motivadora pero alcanzable)',
        value: 'livePortfolio'
    },
    {
        id: 6,
        question: '¿Cuánto ganas mensualmente aproximadamente? (USD)',
        value: 'salaryMonthly'
    },
    {
        id: 7,
        question: '¿Cuánto presupuesto mensual consideras que necesitas para vivir holgadamente incluidos viajes y otros gustos? (USD)',
        value: 'budgetMonthly'
    },
    {
        id: 8,
        question: '¿Cuánto podrías ahorrar mensualmente sin afectar significativamente tu estilo de vida actual? (USD)',
        value: 'saveMonthly'
    },
    {
        id: 9,
        question: '¿Tienes hoy ahorros o inversiones acumuladas? (USD)',
        value: 'investment'
    }
];

export const QUESTION_MANAGEMENT = [
    {
        id: 1,
        question: 'Nombres y apellidos',
        value: 'name'
    },
    {
        id: 2,
        question: 'Edad',
        value: 'age'
    },
    {
        id: 3,
        question: 'Correo electrónico',
        value: 'email'
    },
    {
        id: 4,
        question: 'País de residencia',
        value: 'country'
    },
    {
        id: 5,
        question: '¿Cuál es su conocimiento del mercado de capitales?',
        value: 'capitalKnowledge'
    },
    {
        id: 6,
        question: '¿Cuál es su objetivo de inversión?',
        value: 'objectiveInvestment'
    },
    {
        id: 7,
        question: '¿Hace cuánto realiza inversiones financieras',
        value: 'investmentFinancial'
    },
    {
        id: 8,
        question: '¿Cuándo piensa retirar sus inversiones?',
        value: 'retirementDate'
    },
    {
        id: 9,
        question: 'Si sus inversiones perdieran un 25% en los últimos meses, ¿qué haría?',
        value: 'retirementAction'
    },
    {
        id: 10,
        question: '¿Cuánto capital estima invertir? (USD)',
        value: 'amountInvestment'
    },
    {
        id: 11,
        question: '¿Qué nivel de retorno y variación de precios está dispuesto a aceptar?',
        value: 'returnVariation'
    },
    {
        id: 12,
        question: '¿Qué porcentaje de sus ahorros totales representaría esa inversión?',
        value: 'percentageSavings'
    }
]